<template>
    <drag-modal :visible="$store.state.dislog.Compensation" @cancel="close" title='本案代偿明细' width='800px'>
        <div class="ztable">
            <div class="thead">
                <div class="td">时间</div>
                <div class="td">金额</div>
            </div>
            <div class="tr">
                <div class="th" v-for='i in list' :key="i.id">
                    <div class="td">
                        {{ i.time.slice(0, 10) }}
                    </div>
                    <div class="td">
                        {{ i.amount/100 }}
                    </div>
                </div>
            </div>
        </div>
        <div class="pages" v-if='totals > 10'>
            <a-pagination v-model="form.page" :total="totals" show-less-items @change='nturn' />
        </div>
    </drag-modal>
</template>
<script>
import { yearFormat } from '../../../assets/js/formData';

// import { causeStepLog } from '@/server/collection'
export default {
    name: 'Compensation',
    props: {
        type: Boolean,
        id: Number,
        i: Object,
    },
    data() {
        return {
            form: {
                page: 1,
                limit: 10
            },
            list: [],
            totals: 0
        }
    },
        watch: {
        i: {
            handler(newVal) {
                if (newVal.accuser_id) {
                    this.list = newVal.compensation
                }

            },
            deep: true
        },
    },
    created() {
        this.getList()
    },
    methods: {
        close() {
            this.$store.dispatch('openkey', { key: 'Compensation', by: false })
        },
        endsub(i) {
            this.$emit('sub', i)
        },
        nturn(val) {
            this.form.page = val;
            this.getList()
        },
        getList() {
            // causeStepLog(Object.assign(this.type ? { loan_id: this.id } : { cause_id: this.id }, this.form), this.type).then(res => {
            //     this.totals = res.count
            //     this.list = res.list
            // })
        }
    }
}
</script>
<style lang="less" scoped>
.causeStepLog {
    padding-bottom: 20px;
    background: #fff;

    .h2 {
        margin-bottom: 20px;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        height: 62px;
        border-bottom: 1px solid #efefef;
        padding: 0 20px;
        font-size: 1rem;
        font-weight: bold;
        color: #0e2949;
    }
}

.ztable {
    overflow: hidden;

    // justify-content: space-between;
    // table {
    //   float: left;
    //   margin-right: 20px;
    //   border: 1px solid #ebebeb;
    //   max-width: 48%;
    //   thead {
    //     td {
    //       text-align: center;
    //       padding: 0;
    //       border-right: 1px solid #ebebeb;
    //     }
    //   }
    //   tbody {
    //     tr {
    //       td {
    //         text-align: center;
    //         padding: 0;
    //         border-right: 1px solid #ebebeb;
    //       }
    //     }
    //   }
    // }
    .thead {
        width: 100%;
        background: #f4f5f9;
        border: 1px solid #efefef;
        display: flex;

        .td {
            flex: 1;
            line-height: 36px;
            text-align: center;
            font-size: 0.875rem;
            font-weight: bold;
            color: #102b4b;


        }

    }

    .tr {
        display: flex;
        flex-wrap: wrap;

        .th {
            width: 100%;
            display: flex;
            border-left: 1px solid #efefef;
            border-bottom: 1px solid #efefef;

            .td {
                flex: 1;
                width: 33.3%;
                text-align: center;
                line-height: 40px;
                background: #ffffff;
                border-right: 1px solid #efefef;
                padding: 0 10px;
                font-size: 0.875rem;
                color: #102b4b;


            }

            &:nth-child(2n) {
                border-left: 0 none;
            }
        }
    }
}
</style>